export const config = {
    phoneNumberToSend: process.env.REACT_APP_WA_NUMBER,
    serverUrl: process.env.REACT_APP_SERVER_URL,
}